import React, { useContext, useState } from "react";
import {
  IonCol,
  IonRow,
} from "@ionic/react";
import { Button, CardAsistencia, Modal, Subtitulo, Titulo } from "app-principal-componentes-visuales";
import './ServicioEnCurso.scss'
import { DETALLE_CASO, ESTADOS_ASIGNADOS, ESTADOS_CONFIRMADOS, SERVICIO_EN_CURSO, TITULO_PREGUNTA } from "../../utils/constants";
import Contactanos from "../../components/Modals/Contactanos/Contactanos";
import { capitalizeString } from "../../utils/utils";
import { AsistenciaMedicaContext } from "../../contexts/AsistenciaMedicaContext";
import PageWrapper from "../../components/PageWrapper/PageWrapper";

const ServicioEnCurso = ({history})  => {

  const { asistenciaMedica } = useContext(AsistenciaMedicaContext);
  let {servicioEnCurso} = history.location.state;
  const fechaCreacion = new Date(servicioEnCurso.fechaCreacion)
  const mesActual = new Intl.DateTimeFormat('es-ES', { month: 'short'}).format(fechaCreacion);
  const [detalleCasoModal, setDetalleCasoModal] = useState(false);
  const [ showContactanosModal, setShowContactanosModal ] = useState(false);
  const {estadoSalus} = servicioEnCurso;

  /**
   * Metodo que realiza la validacion del estado para casos asignados
   */
  const validarEstadoAsignado = () => {
    return ESTADOS_ASIGNADOS.includes(estadoSalus) || estadoSalus === '' ? true : false;
  }

  /**
   * Metodo que realiza la validacion del estado para casos confirmados
   */
  const validarEstadoConfirmado = () => {
      return ESTADOS_CONFIRMADOS.includes(estadoSalus) ? true : false;
  }

  const handleVerDetalle = () => {
    let casoEnCursoSeleccionado = { casoEnCursoSeleccionado: servicioEnCurso, from: SERVICIO_EN_CURSO };
    history.push(DETALLE_CASO, casoEnCursoSeleccionado);
  }

  return (
    <>
      <PageWrapper 
        pageClassName='asistencia-medica-servicio-en-curso' 
        socio={asistenciaMedica.usuario} 
        className='servicio_en_curso_container'
        path={SERVICIO_EN_CURSO} >
          <div>
            <IonRow>
              <IonCol size="12">
                <Titulo className="titulo-servicio-en-curso"
                  fontSm
                  titulo={`Existe una solicitud en curso para ${capitalizeString(servicioEnCurso.principal.nombre)}`}
                  id="titulo-asistencia-servicio-en-curso"
                />
              </IonCol>
            </IonRow>

            <IonRow>
              <IonCol size="12">
                <Subtitulo className="subtitulo-servicio-en-curso"
                  titulo="Si necesit&aacute;s m&aacute;s informaci&oacute;n sobre esta solicitud, pod&eacute;s escribirnos por Whatsapp o llamarnos."
                  id="subtitulo-servicio"
                />
              </IonCol>
            </IonRow>
            
            <IonRow>
              <IonCol size="12">
                <CardAsistencia
                  dia={fechaCreacion.getDate().toString()}
                  id="asistencia-medica-card-servicio-en-curso"
                  mes={mesActual}
                  turnos={[
                    {
                      creada: validarEstadoAsignado(),
                      enEspera: validarEstadoConfirmado(),
                      especialidadPara: servicioEnCurso.descripcion,
                      verDetalle: true,
                      prestador: capitalizeString(servicioEnCurso.principal.nombre + ' ' + servicioEnCurso.principal.apellidos),
                      onClick: () => {handleVerDetalle()},
                    }
                  ]}
                />
              </IonCol>
            </IonRow>
          </div>
            
          <IonRow>
            <IonCol size="6" className="footer__button">
              <Button
                label="Volver"
                onClick={() => {history.goBack()}}
              />
            </IonCol>
            <IonCol size="6" className="footer__button">
              <Button
                label="Contactanos"
                primary
                onClick={()=>{setShowContactanosModal(true)}}
              />
            </IonCol>
          </IonRow>
        </PageWrapper>
          
        <Modal
          className="modal_web"
          hideCloseBtn={false}
          //@ts-ignore
          //TODO VALIDAR QUE MODAL MOSTRAR
          component={<Contactanos menorSeisMeses={true} titulo={TITULO_PREGUNTA} servicioEnCurso/>}
          setShowModal={setShowContactanosModal}
          showModal={showContactanosModal}
          id="contactanos"
        />
      </> 
  );
};

export default ServicioEnCurso;
